enum DashboardEntityType {
    Orders = 'orders',
    Settlements = 'settlements',
    Checkouts = 'checkouts',
}

export default DashboardEntityType;
